import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement("g", { clipPath: "url(#hrs_svg__clip0_6717_79989)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M100 50c0 27.612-22.388 50-50 50-27.613 0-50-22.388-50-50C0 22.387 22.387 0 50 0c27.612 0 50 22.387 50 50z",
      fill: "#EB004B"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M32.783 60.07v-7.99H21.79v7.99h-5.125V39.893h5.125v7.937h10.992v-7.937h5.096V60.07h-5.096zm13.512-10.858v-5.179h7.25c2.283 0 3.133 1.034 3.133 2.521 0 1.488-.874 2.654-3 2.654H46.3l-.004.005zm11.125 3.505c2.763-.85 4.408-2.921 4.408-6.292 0-4.754-3.054-6.533-8.045-6.533H41.17V60.07h5.125v-6.717h5.896l4.354 6.717h5.788l-4.913-7.354zm20.842 1.433c0 1.62-2.23 2.046-5.23 2.046-3.983 0-7.462-.85-9-1.567v4.488c2.259.691 5.047 1.22 9 1.22 6.717 0 10.3-1.7 10.3-6.425 0-4.141-2.416-5.52-9.824-5.974-3.45-.213-4.567-.425-4.567-2.017 0-1.592 2.125-2.15 4.938-2.15 3.691 0 6.983.85 8.337 1.541v-4.487c-1.7-.638-4.462-1.196-8.1-1.196-7.513 0-10.25 2.309-10.25 6.53 0 4.22 2.388 5.52 9.85 5.974 3.425.213 4.542.425 4.542 2.017",
      fill: "#fff"
    }
  )),
  /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "hrs_svg__clip0_6717_79989" }, /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h100v100H0z" })))
);
export {
  t as default
};
